import { render } from "./UserAccountDelete.vue?vue&type=template&id=fa403eb4&scoped=true"
import script from "./UserAccountDelete.vue?vue&type=script&lang=js"
export * from "./UserAccountDelete.vue?vue&type=script&lang=js"

import "./UserAccountDelete.vue?vue&type=style&index=0&id=fa403eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa403eb4"]])

export default __exports__